<template>
  <div class="call_native_wrapper">
    <div class="call_native_float_button" id="wx_open_app_float_button">
      <WXLaunchBtn
        @error="handleWxLunchBtnError"
        @wxClick="handleWxClick"
        :schema="schema"
      >
        <template slot="default">
          <div class="icon_text" id="openBtn" @click="callNativeAmap">高德地图APP内打开</div>
        </template>
      </WXLaunchBtn>
    </div>
  </div>
</template>
<script>
import { webviewInfo, log } from '@ali/amap-lib';
import getShareLogParams from '@ali/amap-call-native/getShareLogParams';
import WXLaunchBtn from './WXLaunchBtn.vue';

export default {
  props: {
    // schema跳转地址
    schema: {
      type: String,
      default: '',
    },
    // 页面类型
    pageType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: true,
      share_channelSpm: 'amap.2019_push_template.call.call_amap',
    };
  },
  components: {
    WXLaunchBtn,
  },
  created() {
    if (!webviewInfo.isInAmap()) {
      const params = getShareLogParams({
        page_type: this.pageType
      });
      console.log(params, '曝光=====埋点全链路参数');
      // eslint-disable-next-line no-undef
      window?.AmapTracker?.recordEXP('call.call_amap', {
        params: {
          ...params,
          share_channelSpm: this.share_channelSpm
        },
      });
    }
  },
  methods: {
    callNativeAmap() {
      this.openAmapLog();
      this.$emit('goAmap');
    },
    // open-tag点击需要埋点
    handleWxClick() {
      this.openAmapLog();
      this.$emit('openAmapLog', 'opentag');
    },
    // 如果wx launch出现错误的话，就使用原来的逻辑
    handleWxLunchBtnError() {
      this.openAmapLog();
      this.$emit('goAmap');
    },

    openAmapLog() {
      log.log('bottom_go_amap');
    }
  }
};
</script>

<style lang="scss">
@import "../css/index";
@import "../../../common/css/common-mixin";
.call_native_wrapper {
    bottom: 0;
    left: 0;
    position: fixed;
    width: 7.5rem;
    height: 6rem;
    background: linear-gradient(to top, rgba(255,255,255,1), rgba(255,255,255,0));
    .call_native_float_button{
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: 0.6rem;
      left: 1.75rem;
      width: 4rem;
      height: 0.8rem;
      border-radius: 1rem;
      background: linear-gradient(to right, #1a66ff, #1a8cff);
      .icon_text{
        width: 4rem;
        text-align: center;
        height: 0.8rem;
        font-size: 0.28rem;
        line-height: 0.8rem;
        color: white;
      }
    }
}

</style>
